import { PositiveUniversalMeasure, TextRun, UnderlineType } from "docx";

export const useConvertQuillDeltaToTextRuns = (
  ops: any,
  fontSize: number,
  color: string = "#000000",
  includeLineBreaks: boolean = true
) => {
  if (ops == null || ops == undefined) return [];

  const textRunsArray = [];

  let currentTextRuns = [] as TextRun[];
  ops.forEach((op: any) => {
    if (typeof op.insert === "string") {
      // Determine formatting from attributes

      const lines = (op.insert as string).split("\n");

      let index = 0;
      for (var line of lines) {
        const formatting = op.attributes || {};
        const textRun = new TextRun({
          text: line.replace(/[\u200B-\u200D\uFEFF]/g, ""),
          size: fontSize,
          color: color,
          bold: formatting.bold || false,
          italics: formatting.italic || false,
          underline: formatting.underline
            ? { type: UnderlineType.SINGLE }
            : undefined,
          strike: formatting.strike || false,
        });
        currentTextRuns.push(textRun);

        if (lines.length > 1 && index < lines.length - 1 && includeLineBreaks) {
          textRunsArray.push(currentTextRuns);
          currentTextRuns = [];
        }

        index++;
      }
    }

    // if ((op.insert as string).includes("\n") && includeLineBreaks) {
    //   textRunsArray.push(currentTextRuns);
    //   currentTextRuns = [];
    // }
  });

  // Handle any remaining TextRuns
  if (currentTextRuns.length > 0) {
    textRunsArray.push(currentTextRuns);
  }

  return textRunsArray;
};
